import Media from 'Media/component/Media.vue';
import Modal from 'Site/component/Modal.vue';
import WallMediaPicker from 'Wall/component/WallMediaPicker.vue';

export default {
    components: {
        Media,
        WallMediaPicker,
        Modal
    },
    computed: {
        mediaIds() {
            return this.medias.map(media => media.id);
        }
    },
    data() {
        return {
            mediaLimit: 3,
            medias: [],
            showMediaPicker: false
        };
    },
    methods: {
        removeMedia(mediaItem) {
            const index = this.medias.indexOf(mediaItem);
            this.medias.splice(index, 1);
        },
        updateMedia(mediaItems) {
            if (this.medias.length + mediaItems.length <= this.mediaLimit) {
                this.medias = this.medias.concat(mediaItems);
            } else {
                const maxItemsToAdd = this.mediaLimit - this.medias.length;
                this.medias = this.medias.concat(mediaItems.slice(0, maxItemsToAdd));
                this.$store.dispatch('notify', { msg: this.t.media_limit.replace('%count', maxItemsToAdd) });
            }
            // De-dupe
            const mediaIds = this.medias.map(mediaItem => mediaItem.id);
            this.medias = this.medias.filter((mediaItem, index) => mediaIds.indexOf(mediaItem.id) === index);
        }
    }
};
